import { createPromiseActions } from "../../../utils/createPromiseActions";

export const CheckNetworkAction = createPromiseActions("NETWORK/CHECK_NETWORK");



// WEBPACK FOOTER //
// ./src/store/reducers/network/CheckNetworkAction.js